<template>
  <section class="content">
    <!--
      <mass-unsuspend v-if="action === 'unsuspend'" v-on:unsuspend="unsuspend"></mass-unsuspend>
      <mass-suspend v-if="action === 'suspend'" v-on:suspend="suspend"></mass-suspend>
    -->
    <mass-update
     v-if="action === 'update'"
     v-on:update="update"
     :tariffs="tableData"
     :maxValue="maxValue"
     :details="details"
     :additions="additions"
     :req="updateRequestBody"
     ></mass-update>
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :showSelectAll="true"
      v-on:select-all="deleteAll"
      :tableData="tableData"
      :allowSelect="true"
      tableTitle="Tariffs"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    >
      <div slot="head-slot">
        <div class="form-group" v-if="action === 'unsuspend' || action === 'suspend'">
          <label class="form-label" for="effectiveTo">Effective To</label>
          <input id="effectiveTo" class="mai-date" type="date" v-model="effectiveTo"/>
        </div>
        <div v-if="action === 'unsuspend'" class="btn btn-primary sq" style="width:99%" @click="selectedUnsuspend">
          Unsuspend {{ selectedTariffs.length }} item(s)
        </div>
        <div v-if="action === 'suspend'">
          <input class="form-control" placeholder="Reason" v-model="quickReason"/>
          <div class="btn btn-primary sq" style="width:99%" @click="selectedSuspend">
            Suspend {{ selectedTariffs.length }} item(s)
          </div>
        </div>
      </div>
    </vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  import MassUnsuspend from './MassUnsuspend'
  import MassSuspend from './MassSuspend'
  import MassUpdate from './MassUpdate'
  import event from '../../../../event'
  import API from '../../../../api/endpoints'
  import Composite from '../../../../Composite'

  export default {
    name: 'TariffSearchResults',
    components: {
      vuetable: vuetable,
      Loader,
      MassUnsuspend,
      MassSuspend,
      MassUpdate
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        fields: [
          { header: 'Name', prop: 'name' },
          { header: 'Type', prop: item => item.lookupType !== null ? item.lookupType.name : '' },
          { header: 'Agent', prop: item => item.owner ? item.owner.name : '' }
        ],
        loading: false,
        tableData: [],
        entityName: 'lookup',
        editEntityScreen: 'Admin - Edit/View Tariff',
        action: '',
        details: 0,
        additions: 0,
        quickReason: '',
        effectiveTo: null
      }
    },
    computed: {
      selectAllAction () {
        return this.action && this.action.match('suspend') ? this.action.charAt(0).toUpperCase() + this.action.substr(1) : null
      },
      selectAllBtnClass () {
        return this.action && this.action.match('suspend') ? 'btn-primary' : null
      },
      tariffIds () {
        return this.tableData.map(({id}) => id)
      },
      shouldFetchDetails () {
        return this.action === 'update'
      },
      strParams () {
        return this.decrypt(this.$route.query)
      },
      requestBody () {
        let params = JSON.parse(this.strParams.search)
        return this.modifyParams(params)
      },
      updateRequestBody () {
        let obj = {}
        for (let prop in this.requestBody) {
          obj[prop] = JSON.parse(this.requestBody[prop])
        }
        return obj
      },
      selectedTariffs () {
        return this.tableData.filter(({selected}) => selected).map(({id}) => id)
      }
    },
    methods: {
      updateSelections () {
        if (this.action === 'suspend') {
          this.suspend()
        } else if (this.action === 'unsuspend') {
          this.unsuspend()
        } else {
          this.deleteAll(this.tariffIds.map(id => {
            return { id }
          }))
        }
      },
      deleteAll (items) {
        let count = items.length
        if (count > 0) {
          let n = 0
          event.$emit('loading-on', { title: 'Deleting items' })
          items.forEach(({id}) => {
            this.$http.delete(API.DELETE_ADMIN_ENTITY('lookup', id))
            .then(res => { /* No Op */ })
            .catch(err => {
              console.log(err)
              event.$emit('toast', { type: 'error', message: 'An error occured deleting tariff with id ' + id })
            }).then(() => {
              if (++n === count) {
                event.$emit('loading-off')
                event.$emit('toast', { type: 'success', message: 'Complete' })
                this.getResults()
              }
            })
          })
        }
      },
      displayLocation (location) {
        let str = ''
        if (location.address) {
          str += location.address
        }
        if (location.subdivision) {
          str += `, ${location.subdivision}`
        }
        if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
          str += `, ${location.country.code}`
        }
        return str
      },
      parsePropertyHaskKeyToObjectProperty (key) {
        const shortKeyToProperKey = {
          c: 'code',
          n: 'name',
          d: 'description',
          lT: 'lookupType',
          s: 'suspended',
          o: 'owner',
          cN: 'contractName',
          m: 'mode',
          sT: 'shipmentType',
          tT: 'transportType',
          gT: 'goodsType',
          oL: 'originLocation',
          dL: 'destinationLocation',
          oCL: 'onCarriageLocation',
          pCL: 'preCarriageLocation',
          cT: 'containerType',
          wL: 'woodLoose',
          miB: 'minimumBreakpoint',
          maB: 'maximumBreakpoint'
        }
        if (shortKeyToProperKey.hasOwnProperty(key)) {
          return shortKeyToProperKey[key]
        }
        return key
      },
      updateAction (params) {
        this.action = params.hasOwnProperty('action') ? params.action : this.action
      },
      modifyParams (params) {
        let obj = {}
        if (params.hasOwnProperty('l')) {
          const lookup = this.transformFilterRequestData(params.l)
          if (Object.keys(lookup).length > 0) {
            let lookupWithProperKeys = {}
            for (let prop in lookup) {
              lookupWithProperKeys[this.parsePropertyHaskKeyToObjectProperty(prop)] = lookup[prop]
            }
            obj.lookup = JSON.stringify(lookupWithProperKeys)
          }
        }
        if (params.hasOwnProperty('lD')) {
          const lookupDetail = this.transformFilterRequestData(params.lD)
          if (Object.keys(lookupDetail).length > 0) {
            let lookupDetailWithProperKeys = {}
            for (let prop in lookupDetail) {
              lookupDetailWithProperKeys[this.parsePropertyHaskKeyToObjectProperty(prop)] = lookupDetail[prop]
            }
            obj.lookupDetail = JSON.stringify(lookupDetailWithProperKeys)
          }
        }
        return obj
      },
      getDetails () {
        let opts = {
          params: this.requestBody,
          headers: { 'X-Count-Fetch': 'true' }
        }
        let details = this.$http.get(API.GET_LOOKUP_RELATIONS('lookup-detail'), opts)
        let add = this.$http.get(API.GET_LOOKUP_RELATIONS('lookup-addition'), opts)
        Promise.all([add, details]).then(res => {
          this.additions = this.getValue(res[0].body)
          this.details = this.getValue(res[1].body)
        }).catch(err => {
          console.log(err)
          event.$emit('toast', {
            type: 'warning',
            message: 'Unable to load all resources; lines and/or accesorial data unable to load; try refining your search'
          })
        }).then(() => {
          this.loading = false
        })
      },
      getValue ({ value }) {
        return value || 0
      },
      getHttpPromise (req, opts) {
        return this.$http.get(API.GET_LOOKUPS, {
          params: req,
          headers: { ...opts, 'X-Lazy-Fetch': 'false' }
        })
      },
      loadMore () {
        if (!this.isFetching && !this.dataFullyLoaded) {
          this.isFetching = true
          this.page++
          const data = this.getHttpPromise(this.requestBody, { 'X-Limit': '500', 'X-Page-Number': String(this.page) })
          data.then(({data}) => {
            this.tableData.push(...data.map(o => {
              return { ...o, selected: false }
            }))
          }).catch(err => {
            console.log(err)
          }).then(() => {
            this.isFetching = false
          })
        }
      },
      fetchMaxValue () {
        const data = this.getHttpPromise(this.requestBody, { 'X-Count-Fetch': 'true' })
        data.then(({data}) => {
          this.notifyResults(true, data.value)
          this.maxValue = data.value
        })
        .catch(err => console.log(err))
      },
      getData (req) {
        this.page = 1
        this.loading = true
        this.isFetching = true
        let data = this.getHttpPromise(req, { 'X-Limit': '500', 'X-Page-Number': '1' })
        data.then(({data}) => {
          if (data.length) {
            this.tableData = data.map(o => {
              return { ...o, selected: false }
            })
            if (this.shouldFetchDetails) {
              this.getDetails()
            }
          } else {
            this.tableData = []
          }
        })
        .catch(err => {
          console.log(err)
          this.notifyResults(false)
          this.tableData = []
        }).then(() => {
          this.isFetching = false
          this.loading = false
          this.fetchMaxValue()
        })
      },
      getResults () {
        if (!this.entityName) {
          window.console.warn(`If you are seeing this message, component '${this.$options.name}' has not overwritten the 'entityName' property`)
        } else {
          const strParams = this.decrypt(this.$route.query)
          if (strParams.hasOwnProperty('search')) {
            let params = JSON.parse(strParams.search)
            this.updateAction(params)
            let req = this.modifyParams(params)
            if (Object.keys(req).length > 0) {
              this.getData(req)
            } else {
              event.$emit('toast', { type: 'warning', message: 'Please ensure you refine your filter search' })
            }
          } else {
            event.$emit('toast', { type: 'error', message: 'An error occurred; please try again or contact support' })
          }
        }
      },
      handleMassStatusChange (type, promise, length = 0) {
        promise.then(data => {
          this.action = ''
          this.effectiveTo = null
          this.$nextTick(this.getResults)
          event.$emit('toast', { type: 'warning', message: `A total of ${length} tariffs were ${type}ed` })
        }).catch(err => {
          console.log(err)
          event.$emit('toast', { type: 'error', message: 'An error occurred; please try again or contact support' })
        }).then(() => {
          event.$emit('loading-off')
        })
      },
      unsuspend () {
        if (this.tariffIds.length === 0) {
          event.$emit('toast', { type: 'warning', message: 'Please ensure there are tariffs to unsuspend' })
        } else {
          event.$emit('loading-on')
          this.handleMassStatusChange('unsuspend', this.$store.dispatch('admin/massTariffRequestStatusUpdate', { status: '0', tariffs: this.tariffIds, effectiveTo: this.effectiveTo }), this.tariffIds.length)
        }
      },
      suspend (reason) {
        if (this.tariffIds.length === 0) {
          event.$emit('toast', { type: 'warning', message: 'Please ensure there are tariffs to suspend' })
        } else {
          event.$emit('loading-on')
          this.handleMassStatusChange('suspend', this.$store.dispatch('admin/massTariffRequestStatusUpdate', { status: '1', tariffs: this.tariffIds, reason, effectiveTo: this.effectiveTo }), this.tariffIds.length)
        }
      },
      selectedSuspend () {
        if (this.selectedTariffs.length === 0) {
          event.$emit('toast', { type: 'warning', message: 'Please ensure there are tariffs to suspend' })
        } else {
          event.$emit('loading-on')
          this.handleMassStatusChange('suspend', this.$store.dispatch('admin/massTariffRequestStatusUpdate', { status: '1', tariffs: this.selectedTariffs, reason: this.quickReason, effectiveTo: this.effectiveTo }), this.selectedTariffs.length)
        }
      },
      selectedUnsuspend () {
        if (this.selectedTariffs.length === 0) {
          event.$emit('toast', { type: 'warning', message: 'Please ensure there are tariffs to unsuspend' })
        } else {
          event.$emit('loading-on')
          this.handleMassStatusChange('unsuspend', this.$store.dispatch('admin/massTariffRequestStatusUpdate', { status: '0', tariffs: this.selectedTariffs, effectiveTo: this.effectiveTo }), this.selectedTariffs.length)
        }
      },
      update () {
        console.log('update')
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// TariffSearchResults.vue?b638f1a6